import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import logoUrl from '../Resources/logo-salidas.png';
import "./DownloadModal.css";

const DownloadModal = ({ isOpen, onClose, onDownload }) => {
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    // Validación simple de correo
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsEmailValid(emailRegex.test(value));
  };

  const handleDownload = async () => {
    if (isEmailValid) {
      setIsSending(true);

      try {
        // Configura EmailJS
        const serviceID = "service_xsw2d7w"; // Reemplaza con tu Service ID
        const templateID = "template_1rkzht4"; // Reemplaza con tu Template ID
        const publicKey = "JAVNnk3iUoLyFJEPN"; // Reemplaza con tu Public Key

        // Envía el correo
        await emailjs.send(
          serviceID,
          templateID,
          { email }, // Variables definidas en tu plantilla
          publicKey
        );

        // Llamar a la función de descarga
        onDownload(email);
        onClose();
      } catch (error) {
        console.error("Error al enviar el correo:", error);
        alert("Hubo un error al registrar el correo. Inténtalo nuevamente.");
      } finally {
        setIsSending(false);
      }
    }
  };

  const handleLogoDownload = () => {
    const element = document.createElement("a");
    element.href = logoUrl;
    element.download = "Logo_Salidas_Inclusivas.png";
    element.click();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Descargar Item</h2>
        <p>✨ Al descargar estos pictogramas, estás contribuyendo a que más personas disfruten de experiencias inclusivas.</p>
        <p>📧 <strong>Registro obligatorio:</strong> Para acceder al material, necesitás registrarte con un correo electrónico.</p>
        <p>📘 <strong>Asesoramiento gratuito:</strong> Te pedimos que nos escribas un mail a <a href="mailto:contacto@salidasinclusivas.com">contacto@salidasinclusivas.com</a> para coordinar una reunión de supervisión inicial sin cargo de 20 minutos. Esto garantiza el uso correcto de los pictogramas y la guía que los acompaña.</p>
        <p>📎 <strong>Importante:</strong> Si utilizás nuestros pictogramas, descargá también el logo de Salidas Inclusivas e incluilo en los espacios donde se utilicen.</p>
        <p>🙏 ¡Gracias por confiar en Salidas Inclusivas y ser parte del cambio!<br />
        — <br />Equipo de Salidas Inclusivas</p>
        <input
          type="email"
          placeholder="Correo electrónico"
          value={email}
          onChange={handleEmailChange}
        />
        <div className="modal-actions">
          <button class="btn-primary" onClick={onClose} disabled={isSending}>
            Cancelar
          </button>
          <button class="btn-primary" onClick={handleDownload} disabled={!isEmailValid || isSending}>
            {isSending ? "Enviando..." : "Descargar"}
          </button>
          <button class="btn-primary" onClick={handleLogoDownload}>
            Descargar Logo
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadModal;